// Consent initialization and migration
// This should be called when the app starts to handle any existing consent data

import { migrateConsentData } from '../services/consentService';

/**
 * Initialize consent system
 * Call this when the app starts to migrate any existing consent data
 */
export const initializeConsentSystem = () => {
  try {
    // Migrate any old consent data to new format
    migrateConsentData();
    console.log('Consent system initialized successfully');
  } catch (error) {
    console.error('Error initializing consent system:', error);
  }
};
